import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { hideBeforeSm } from "../../../theme/helpers/media";
import Textarea from "./Textarea";
import { keyCode } from "../../../enums/keyCodeEnums";
import { PRODUCT_NOTE_TEST_ID } from "../constants";
export var CardNote = styled.div.withConfig({
  displayName: "CommentField__CardNote",
  componentId: "g21b1v-0"
})(["z-index:-1;position:absolute;left:0;right:0;bottom:6px;padding:6px 12px 12px 12px;margin:0 auto;transform:translateY(100%);opacity:0;visibility:hidden;background-color:", ";transition:opacity 200ms ease-out;&:before{content:'';position:absolute;left:0;right:0;top:-5px;z-index:10;height:10px;opacity:1;visibility:visible;background-color:", ";}&:after{content:'';position:absolute;left:0;right:0;bottom:0;top:0;opacity:1;z-index:-1;visibility:visible;", "}", ""], function (_ref) {
  var bgColor = _ref.theme.comment.field.bgColor;
  return bgColor;
}, function (_ref2) {
  var bgColor = _ref2.theme.comment.field.bgColor;
  return bgColor;
}, function (_ref3) {
  var _ref3$theme = _ref3.theme,
      borderRadius = _ref3$theme.borderRadius,
      shadow = _ref3$theme.shadow;
  return css(["border-bottom-left-radius:", "px;border-bottom-right-radius:", "px;box-shadow:", ";"], borderRadius, borderRadius, shadow);
}, hideBeforeSm);
var TextareaWithTheme = styled(Textarea).attrs(function (_ref4) {
  var _theme$comment, _theme$comment$field;

  var theme = _ref4.theme;
  return {
    textAreaTheme: {
      fontWeight: theme === null || theme === void 0 ? void 0 : (_theme$comment = theme.comment) === null || _theme$comment === void 0 ? void 0 : (_theme$comment$field = _theme$comment.field) === null || _theme$comment$field === void 0 ? void 0 : _theme$comment$field.fontWeight
    }
  };
}).withConfig({
  displayName: "CommentField__TextareaWithTheme",
  componentId: "g21b1v-1"
})([""]);
var CommentField = forwardRef(function (_ref5, ref) {
  var value = _ref5.value,
      _ref5$placeholder = _ref5.placeholder,
      placeholder = _ref5$placeholder === void 0 ? 'Пожелание' : _ref5$placeholder,
      onSubmit = _ref5.onSubmit,
      onChange = _ref5.onChange,
      _ref5$maxLength = _ref5.maxLength,
      maxLength = _ref5$maxLength === void 0 ? 180 : _ref5$maxLength,
      onFocus = _ref5.onFocus,
      className = _ref5.className,
      isKomus = _ref5.isKomus;

  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === keyCode.Enter) {
      e.preventDefault();

      if (typeof ref !== 'function' && (ref === null || ref === void 0 ? void 0 : ref.current)) {
        // eslint-disable-next-line no-unused-expressions
        ref.current.blur();
      }
    }
  };

  var handleBlur = function handleBlur(e) {
    var textContent = e.currentTarget.textContent;
    if (value !== textContent) onSubmit(textContent);
  };

  return React.createElement("div", {
    className: className
  }, React.createElement(CardNote, null, React.createElement(TextareaWithTheme, {
    testId: PRODUCT_NOTE_TEST_ID,
    placeholder: placeholder,
    ref: ref,
    text: value,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    onChange: onChange,
    maxLength: maxLength,
    onFocus: onFocus,
    isKomus: isKomus
  })));
});
export default CommentField;